/**
 * ImageSelector builder — verbatim from v1 (research/03 §5, §15.4/15.5;
 * REQ-ELEM-2). Preserves the load-bearing missing `]` in the dropdown's
 * name="properties[{Name}"> (ERRATA #6: only the bracket is missing, the
 * closing quote IS present), the `<labele>` swatch tag, the `</select ></div>`
 * closer, and the display:none preloader <img> tags outside the .element div.
 */
import { appState } from "../state/app-state";
import { escapeHtml, getConditionalDisplay, getToolTipHtml , getElementWidthClass, optionValueAttr, t , dirAttr } from "./base";

export function buildImageSelector(element: any): string {
  var conditionalDisplay = getConditionalDisplay(element);
  var enableSwatch = element.enableSwatch;
  let toolTipHtml = getToolTipHtml(element, "div");
  var ddl = "";
  if (enableSwatch === false) {
    ddl =
      "<div class='element" + getElementWidthClass(element) + "' data-element='" +
      element.Identifier +
      "' " +
      conditionalDisplay.conditionalTemplate +
      "><label style='color:" +
      appState.calculatorStyling.upperTextColor +
      "'" + dirAttr(element.Name) + ">" +
      t(element.Name) +
      toolTipHtml +
      "</label><select style='border:1px solid yellow' data-showimage='" +
      element.showImage +
      "' data-identifier='" +
      element.Identifier +
      "' onchange='ChangeEvent(\"" +
      element.ElementType +
      "\", this)' class='calc-prop' data-calcname='" +
      element.Name +
      "' name=\"properties[" +
      element.Name +
      '">';

    element.Options.forEach((option: any) => {
      let escapedValue = escapeHtml(option.value);
      let escapedLabel = escapeHtml(option.label);
      let escapedFilePath = escapeHtml(option.filepath);
      // Translations v1: visible text swapped; data-label (the pricing key) stays canonical.
      let visibleLabel = escapeHtml(t(option.label));
      ddl +=
        "<option data-val='" +
        escapedValue +
        "' data-label='" +
        escapedLabel +
        "' data-imgsrc='" +
        escapedFilePath +
        "' " +
        optionValueAttr(escapedLabel, visibleLabel) +
        dirAttr(option.label) +
        " >" +
        visibleLabel +
        "</option>";
    });
    ddl += "</select ></div>";
    element.Options.forEach((option: any) => {
      let escapedFilePath = escapeHtml(option.filepath);
      ddl += "<img src='" + escapedFilePath + "' style='display:none' />";
    });
  } else {
    ddl =
      "<div class='element" + getElementWidthClass(element) + "' data-element='" +
      element.Identifier +
      "' " +
      conditionalDisplay.conditionalTemplate +
      "><label class='element-label' data-identifier='" +
      element.Identifier +
      "' style='color:" +
      appState.calculatorStyling.upperTextColor +
      "'" + dirAttr(element.Name) + ">" +
      t(element.Name) +
      toolTipHtml +
      "</label><fieldset class='swatch-picker'>";

    let swatchIndex = 0;
    element.Options.forEach((option: any) => {
      swatchIndex++;
      let swatchedChecked = swatchIndex === 1 ? "checked" : "";
      let escapedLabel = escapeHtml(option.label);
      let escapedValue = escapeHtml(option.value);
      let escapedFilePath = escapeHtml(option.filepath);
      ddl +=
        // Translations v1: the hover title is what the shopper reads; the radio's value= stays canonical.
        "<labele class='swatch-label ctooltip' cpctitle='" +
        escapeHtml(t(option.label)) +
        "'><input type='radio' class='calc-prop' data-identifier='" +
        element.Identifier +
        "' " +
        swatchedChecked +
        " data-showimage='" +
        element.showImage +
        "' value='" +
        escapedLabel +
        "' data-val='" +
        escapedValue +
        "' data-imgsrc='" +
        escapedFilePath +
        "' data-calcname='" +
        element.Name +
        "' name=\"properties[" +
        element.Name +
        ']" onchange=\'ChangeEvent("' +
        element.ElementType +
        "\", this)' /><img src='" +
        escapedFilePath +
        "' /></labele>";
    });
    ddl += "</fieldset></div>";
  }
  return ddl;
}
